const en = {
    appName: 'Rikud Israeli',
    dir: 'ltr',
    general: {
        invalid_password: 'Password must contain a minimum of 8 characters',
        invalid_verify_password: 'Passwords do not match',
        loading: 'Loading',
    },
    main: {
        title: 'Most recent dances: ',
        myAccount: 'My Account',
        logout: 'Logout',
        loading: 'Loading Most Recent Dances',
    },
    dance: {
        supportedMediaTypes: 'Supported media types: ',
        mediaAddedSuccessfully: 'Media added successfully',
        name: 'Name',
        lyricists: 'Lyricists',
        composers: 'Composers',
        mediaUrl: 'Media Link',
        selectedMedia: 'Selected Media:',
        uploadMedia: 'Upload Media',
        videos: 'Videos',
        audio: 'Audio',
        WaitingForChoreographerApproval: 'Waiting for choreographer approval',
        song: 'Song',
        video: 'Video',
        addMedia: 'Add Media',
        addMediaForLoggedUsers: 'Add Available Media (Logged in users only)',
        rokdimLink: 'View this dance on Rokdim',
        add: 'Add',
        addLinkMedia: 'Add Link Media',
        addFileMedia: 'Add File Media',
        cancel: 'Cancel',
        danceStyle: 'Dance Style: ',
        uploadDate: 'Upload Date: ',
        creationDate: 'Created: ',
        numOfDownloads: 'Downloaded:',
        numOfViews: 'Viewed:',
        extraInfo: 'More Info',
        extraInfoTooltip: 'Dance Page',
        downloadTooltip: 'Download',
        likeTooltip: 'Like',
        shareTooltip: 'Share',
        deleteTooltip: 'Delete',
        description: 'Description: ',
        composer: 'Composer',
        choreographer: 'Choreographer',
        choreographers: 'Choreographers',
        lyricist: 'lyricist',
        manageRequest: 'manage requests',
        unavailable: 'Unavailable',
        notFound: 'Dance details are currently unavailable...',
        addMediaInfo: `Add media to your current dance by uploading a file or providing a URL.\nMedia will be sent to choreographers for approval.\nView pending media in the 'Waiting for choreographers approval' tab.\nNote: If you are the choreographer, media will be automatically approved.`,
        noMedia: 'There is no media for this dance yet',

        styles: {
            circle: 'Circle',
            couples: 'Couples',
            lines: 'Lines',
            kidsLines: 'Kids lines',
            couplesSwap: 'Couples Swap',
            couplesLines: 'Couples Lines',
            kids: 'Kids',
            kidsCircle: 'Kids Circle',
            kidsCouples: 'Kids Couples',
            threeWay: 'Threeway',
            fourWay: 'Fourway',
        },
        tags: {
            lable: 'Choose Tags:',
            dance: 'dance',
            learn: 'learn',
        },
        songDetails: 'Song Details:',
        videosList: 'Video List:',
        songsList: 'Songs list:',
    },
    newMedia: {
        video: 'Video',
        song: 'Song',
        VIDEO: 'Video',
        SONG: 'Song',
        noMedia: 'There is nothing to show yet.',
        songUpload: 'Upload song:',
        SONGUpload: 'Upload song:',
        videoUpload: 'Add video link:',
        VIDEOUpload: 'Add video link:',
        upload: 'Upload',
        submit: 'Submit',
        fileStatusSuccess: 'the file uploaded sucessfuly.',
        fileStatusError: 'File upload failed, please try again',
        error: 'Video already in use, please enter a new link.',
        warning: 'warning:',
        invalidType: 'Selected media type is unsupported',
        clickToAdd: 'Click to add {{mediaType}}',
        add: 'Upload {{mediaType}}',
        missingTag: 'Please select at least one tag',
        selectAudio: 'Select A file...',
        description: 'Description: ',
        label: 'Choose labels: ',
    },
    myDances: {
        title: 'My Dances',
        mediaForDelete: 'request for delete',
        mediaForUpload: 'request for upload',
        noDances: 'do not have any dance',
        loading: 'Loading',
    },
    search: {
        input: 'Find A Dance...',
        pagination: 'Dances For Page :',
        filtered: 'Find a Dance With...',
        advanced: 'Advanced Search',
        search: 'Search',
        results: 'Closest Results',
        next: 'Next Page',
        previous: 'Previous Page',
        noOptions: 'No options',
        noResults: 'No listed results...',
        filterByStyle: 'Filter by dance type',
        filters: {
            name: 'Name',
            style: 'Style',
            creators: 'Choreographer name',
            firstName: 'Choreographer first name',
            lastName: 'Choreographer last name',
            performer: 'Performer',
            composer: 'Composer',
            lyricist: 'Lyricist',
            artist: 'Lyricist / Composer',
            choreographer: 'Choreographer',
            danceMediasIcons: 'Video / Aduio',
            creationDate: 'Creation Year',
        },
        styles: {
            lines: 'lines',
            trio: 'trio',
            pair: 'pair',
            circles: 'circles',
            changeablePairs: 'changeablePairs',
            childrens: 'childrens',
            childrensParis: 'childrensParis',
            childrensCircles: 'childrensCircles',
            childrensLines: 'childrensLines',
        },
    },
    welcome: {
        continue: 'Continue',
        password: 'Password',
        passwordRequired: 'password is required.',
        confirmPassword: 'Confirm Password',
        forgotPassword: 'Forgot Password?',
        resetPassword: 'Password Reset',
        noMatch: 'Passwords do not match',
        resetEmail: 'Send Password Reset Email',
        alreadyRegistered: 'Already have an Account?',
        login: 'Login',
        logout: 'Logout',
        signIn: 'Sign In',
        register: 'Register',
        email: 'Email',
        invalidEmail: 'valid email is required.',
        welcome: 'Welcome to Rikud-Israeli',
        rememberMe: 'Remember Me',
        newUser: 'New User ?',
        invalidInput: 'Valid {{input}} is required.',
        fullName: 'Full Name',
        firstName: 'First Name',
        lastName: 'Last Name',
        appName: 'Rikud Israeli',
    },
    menu: {
        Home: 'Home',
        MyDances: 'My Dances',
        Search: 'Search',
        MyRequests: 'Manage requests',
    },
    user: {
        firstName: 'First Name:',
        lastName: 'Last Name:',
        email: 'Email:',
        userDescription: 'details:',
        editButton: 'change info',
        backButton: 'Cancel',
        saveButton: 'Save',
        requests: {
            upload: 'Request to upload {{mediaType}}: ',
            delete: 'Request to delete {{mediaType}}: ',
            song: 'song',
            video: 'video',
            VIDEO: 'video',
            pending: 'awaits your approval',
            toDance: 'For Dance - ',
            title: 'Requests awaiting your permission',
            danceName: 'Dance name - {{name}} ',
            loading: 'Loading all requests',
            noRequests: 'You have no pending dances',
        },
    },
    profile: {
        firstName: 'First Name:',
        lastName: 'Last Name:',
        email: 'Email:',
        save: 'Save Changes',
        cancel: 'Cancel',
        upload: 'Select profile image',
        changesSaved: 'Changes saved successfully',
    },
    advancedSearch: {
        search: 'Search',
        name: 'Name',
        style: 'Style',
        choreographers: 'Choreographers',
        performer: 'Performer',
        danceName: 'Dance Name',
        choreographer: 'Choreographer',
        lyricistOrComposer: 'Lyricist / Composer',
        filterByStyle: 'Filter by style',
        composers: 'Composers',
        lyricists: 'Lyricists',
        mediaForApproval: 'מספר מדיה לאישור',
    },
    unlockContent: {
        header: 'Connect to see more content',
        p1: 'To see more content, you must be logged in.',
        p2: 'By connecting you will be able to view your dances, upload media, perform advanced searches for dances and more.',
        loginOrRegister: 'Click here to login or register',
    },
    toolbar: {
        signInSignUp: 'Sign In / Sign Up',
        linkedChoreographer: 'Guide',
    },
    allMediaRequests: {
        allMediaRequests: 'All Media Requests',
        name: 'Choreographer',
        mediaRequests: 'Media Requests',
    },
}
export default en
